import styled from "styles/styled_components";

interface IWarningProps {
  align?: "left" | "right" | "center";
}

const StyledWarning = styled("div")<IWarningProps>`
  color: ${props => props.theme.colors.brandOrange50};
  font-family: ${props => props.theme.text.primaryFamily};
  padding-top: ${props => props.theme.spacing.small};
  text-align: ${props => props.align || "left"};
`;

export default StyledWarning;
